import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import DeleteGroup from '../../../components/Contact/ContactGroups/DeleteGroup/DeleteGroup';
import DrawerConversationGridFilters from '../../../components/Contact/ContactGroups/DrawerConversationGridFilters/DrawerConversationGridFilters';
import DrawerListViewOptions from '../../../components/Contact/DrawerListViewOptions/DrawerListViewOptions';
import MenuContactsSort from '../../../components/Contact/MenuContactsSort/MenuContactsSort';
import SearchContacts from '../../../components/Contact/SearchContacts/SearchContacts';
import { ContactsSegmentsResponse } from '../../../sic-lib/api/segments/types/ContactsSegmentsResponse';
import { ListItem } from '../../../sic-lib/types/Lists';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        height: 'inherit',
        padding: theme.spacing(1),
    },
    flexWrapper: {
        height: 'inherit',
    },
    paper: {
        height: '100%',
        border: `1px solid ${theme.palette.divider}`,
    },
    marginLeft: {
        marginLeft: theme.spacing(1),
    },
}));

interface Props {
    list: ListItem | ContactsSegmentsResponse;
}

export default function HeaderFilters({ list }: Props) {
    const { classes } = useStyles();

    return (
        <div className={classes.root}>
            <Grid
                container
                direction="row"
                wrap="nowrap"
                alignItems="center"
                spacing={2}
                className={classes.flexWrapper}
            >
                <Grid item xs="auto" lg={true}>
                    <Grid
                        container
                        display="flex"
                        alignItems="center"
                        direction="row"
                        wrap="nowrap"
                    >
                        <Grid item xs="auto">
                            <DrawerListViewOptions list={list as ListItem} />
                        </Grid>
                        <Grid item xs="auto" className={classes.marginLeft}>
                            <Typography variant="h6" component="p" noWrap={true}>
                                {list.hasOwnProperty('listId')
                                    ? (list as ListItem).name
                                    : (list as ContactsSegmentsResponse).segmentName}
                            </Typography>
                        </Grid>
                        {list.hasOwnProperty('listId') && (list as ListItem).listId > 0 && (
                            <DeleteGroup list={list as ListItem} />
                        )}
                    </Grid>
                </Grid>
                <Grid item xs={true}>
                    <Paper elevation={0} className={classes.paper}>
                        <SearchContacts />
                    </Paper>
                </Grid>
                <Grid item xs="auto" lg={true}>
                    <Grid
                        container
                        direction="row"
                        wrap="nowrap"
                        justifyContent="flex-end"
                        alignItems="center"
                    >
                        <Grid item xs="auto">
                            {list.hasOwnProperty('listId') && (
                                <MenuContactsSort viewId={(list as ListItem).viewId} />
                            )}
                        </Grid>
                        <Grid item xs="auto" className={classes.marginLeft}>
                            {list.hasOwnProperty('listId') && (
                                <DrawerConversationGridFilters list={list as ListItem} />
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
}
